import { Route,Routes } from "react-router-dom";
import Developers from "./pages/Developers";
import Playground from "./pages/Playground";
import ContactUs from "./pages/terms-and-conditions/ContactUs";
import CancellationAndRefundPolicy from "./pages/terms-and-conditions/CancellationAndRefundPolicy";
import TermsAndConditions from "./pages/terms-and-conditions/TermsAndConditions";
import NotFound from "./pages/NotFound";

const App = () => {
    return (
        <Routes>
            <Route path="/" element ={<Playground/>}/>
            <Route path="/developers" element ={<Developers/>}/>
            <Route path="/playground" element ={<Playground/>}/>
            <Route path="/contact-us" element ={<ContactUs/>}/>
            <Route path="/cancellation-and-refund-policy" element ={<CancellationAndRefundPolicy/>}/>
            <Route path="/terms-and-conditions" element ={<TermsAndConditions/>}/>

            <Route path="*" element ={<NotFound/>}/>
        </Routes>
    );
};

export default App;
